import get from 'lodash.get';
import {
    CLEAR_RESULTS,
    FETCH_ALL_RESULTS,
    FETCH_SHARED_RESULTS,
    FETCH_ITEM_LEVEL_DETAILS,
    FETCH_ALL_ADDITIONAL_RESULTS,
    INVALIDATE_BASIC_COMPREHENSION_RESULT,
    FETCH_D8_RESULTS,
} from '../../actionTypes/shared/apiActionTypes';
import { parseSpellingData, parseTrcItemLevelDetails } from './resultReducerParsers';
import {
    deleteBasicComprehensionResultFromStudentObject,
    mergeStudentData,
} from '../../../utils/shared/resultReducerHelper';
import { resultStateProperties } from '../../../constants/shared/CommonConstants';

export const initialState = {
    data: {},
    isAllResultsFetched: false,
    isAdditionalResultsFetched: false,
    areResultsUpdating: false,
    error: null,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case FETCH_SHARED_RESULTS.SPELLING:
            return {
                ...state,
                data: mergeStudentData(
                    state.data,
                    parseSpellingData(action.response, resultStateProperties),
                    resultStateProperties,
                ),
            };
        case FETCH_ITEM_LEVEL_DETAILS.SUCCESS:
            return {
                ...state,
                data: parseTrcItemLevelDetails(state.data, action.response, action.studentId),
            };
        case CLEAR_RESULTS:
            return {
                ...state,
                data: {},
                isAllResultsFetched: false,
                isAdditionalResultsFetched: false,
            };
        case FETCH_ALL_RESULTS.SUCCESS:
            return {
                ...state,
                isAllResultsFetched: true,
                isAdditionalResultsFetched: false,
            };
        case FETCH_ALL_ADDITIONAL_RESULTS.SUCCESS:
            return {
                ...state,
                isAdditionalResultsFetched: true,
            };
        case FETCH_ALL_RESULTS.ERROR:
        case FETCH_ALL_ADDITIONAL_RESULTS.ERROR:
        case FETCH_D8_RESULTS.ERROR:
            return {
                ...state,
                error: action.error,
            };
        case INVALIDATE_BASIC_COMPREHENSION_RESULT.SUCCESS: {
            const { studentId, resultId, basicComprehensionMeasure } =
                action.additionalResponseParams;
            return {
                ...state,
                data: deleteBasicComprehensionResultFromStudentObject(
                    state.data,
                    studentId,
                    resultId,
                    basicComprehensionMeasure,
                ),
            };
        }
        case FETCH_D8_RESULTS.START:
            return {
                ...state,
                areResultsUpdating: true,
            };
        default:
            return state;
    }
};

const isResultDataFetched = state => state.isAllResultsFetched;

const isAdditionalResultsFetched = state => state.isAdditionalResultsFetched;

const areResultsUpdating = state => state.areResultsUpdating;

const getResults = state => state.data;

const getResultById = (state, resultId) => {
    const results = getResults(state);
    let result = {};
    Object.keys(results).forEach(studentKey => {
        const foundResult = results[studentKey].results.find(
            innerResult => innerResult.resultId === resultId,
        );
        if (foundResult) {
            result = foundResult;
        }
    });

    return result;
};

const getStudentResultsByStudentId = (state, studentId) =>
    get(getResults(state)[studentId], 'results');

export const selectors = {
    isResultDataFetched,
    isAdditionalResultsFetched,
    areResultsUpdating,
    getResults,
    getResultById,
    getStudentResultsByStudentId,
};
